/**
 * Утилиты для синхронизации настроек таблиц
 */

import store from '../store'

/**
 * Ручная синхронизация всех настроек из localStorage в БД
 */
export async function syncAllSettingsToDb() {
    try {
        const result = await store.dispatch('userLocalSettings/SYNC_ALL_SETTINGS_TO_DB')
        return result
    } catch (error) {
        return false
    }
}

/**
 * Загрузка всех настроек из БД
 */
export async function loadAllSettingsFromDb() {
    try {
        const settings = await store.dispatch('userLocalSettings/LOAD_ALL_SETTINGS_FROM_DB')
        return settings
    } catch (error) {
        return null
    }
}

/**
 * Получить настройки конкретной таблицы (умно)
 */
export async function getTableSettings(tableName) {
    try {
        const settings = await store.dispatch('userLocalSettings/GET_TABLE_HEADER_SETTINGS', tableName)
        return settings
    } catch (error) {
        return {}
    }
}

/**
 * Сохранить настройки конкретной таблицы (умно)
 */
export async function saveTableSettings(tableName, settings) {
    try {
        await store.dispatch('userLocalSettings/SET_TABLE_HEADER_SETTINGS_SMART', {
            tableName: tableName,
            settings: settings
        })
        return true
    } catch (error) {
        return false
    }
}

/**
 * Проверить статус синхронизации
 */
export function getSyncStatus() {
    const isEnabled = store.getters['userLocalSettings/IS_DB_SYNC_ENABLED']
    const dbSettings = store.getters['userLocalSettings/DB_TABLE_HEADER_SETTINGS']
    const localSettings = store.getters['userLocalSettings/TABLE_HEADER_SETTINGS']
    
    return {
        isEnabled,
        localSettingsCount: Object.keys(localSettings).length,
        dbSettingsCount: Object.keys(dbSettings).length
    }
}

/**
 * Принудительная инициализация и синхронизация
 */
export async function forceInitializeAndSync() {
    try {
        const result = await store.dispatch('userLocalSettings/INITIALIZE_AND_SYNC')
        return result
    } catch (error) {
        return false
    }
}

// Экспортируем функции в глобальный объект для тестирования в консоли
if (typeof window !== 'undefined') {
    window.tableSettingsSync = {
        syncAllSettingsToDb,
        loadAllSettingsFromDb,
        getTableSettings,
        saveTableSettings,
        getSyncStatus,
        forceInitializeAndSync
    }
    
    // console.log('🔧 Утилиты синхронизации настроек таблиц доступны в window.tableSettingsSync')
    // console.log('Доступные методы:')
    // console.log('- tableSettingsSync.syncAllSettingsToDb() - синхронизировать все настройки')
    // console.log('- tableSettingsSync.loadAllSettingsFromDb() - загрузить из БД')
    // console.log('- tableSettingsSync.getTableSettings("orderTable") - получить настройки таблицы')
    // console.log('- tableSettingsSync.saveTableSettings("orderTable", {...}) - сохранить настройки')
    // console.log('- tableSettingsSync.getSyncStatus() - проверить статус')
    // console.log('- tableSettingsSync.forceInitializeAndSync() - принудительная инициализация')
}
